module.exports = __webpack_public_path__ + "img/fail.4fc69984.png";